import React from "react"
import {
    Image,
    Text,
    Box,
    useIsDarkMode,
} from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import Tent from "~images/lodging/tent.svg"

export default function OutfitterLodgingsEmpty() {
    const styles = useStyles()

    return (
        <Box style={styles.root}>
            <Image
                src={Tent}
                style={styles.lodgeIcon}
                alt={COPY.LODGINGS.NO_LODGING_ALT_TEXT}
            />
            <Text style={styles.text}>
                {COPY.LODGINGS.OUTFITTER_NO_LODGINGS}
            </Text>
        </Box>
    )
}

function useStyles() {
    const isDarkMode = useIsDarkMode()

    return {
        root: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: 600,
            marginTop: "48px",
            marginBottom: "48px",
        },
        lodgeIcon: {
            width: "52px",
            filter: isDarkMode ? "invert(100%)" : "",
            marginRight: "16px",
        },
        text: {
            fontWeight: 600,
            fontSize: "20px",
        },
    }
}
